module.exports = __webpack_public_path__ + "img/CTWP__Sword_03.faddf487.png";